function PoliticaPrivacidade() {
    return (
        <div className="global-pageContainer-left">
            <div className="contribute-container">
                <h1>Política de Privacidade</h1>
                <p className="global-mt">
                    O <strong>Tabuada Divertida</strong> respeita a sua privacidade e se compromete a proteger os dados dos usuários de forma simples, clara e segura.
                </p>
                <p className="global-mt">
                    Não utilizamos cookies nem realizamos qualquer tipo de rastreamento para fins de publicidade ou análise.
                </p>
                <p className="global-mt">
                    O único dado salvo localmente é o <strong>nome do jogador</strong>, que é armazenado no seu próprio navegador com o objetivo de:
                </p>
                <ul className="global-mt" style={{ paddingLeft: '1rem' }}>
                    <li>Exibir seu nome no ranking;</li>
                    <li>Manter o histórico de respostas durante a sessão atual.</li>
                </ul>
                <p className="global-mt">
                    Nenhuma informação pessoal é enviada ou compartilhada com terceiros. Todo o histórico é armazenado apenas na <strong>sessão atual do navegador</strong>, sendo descartado ao fechar a aba ou o navegador.
                </p>
                <p className="global-mt">
                    Esta plataforma é voltada para fins educacionais e está em constante evolução. Em caso de dúvidas ou sugestões, entre em contato com o desenvolvedor.
                </p>
            </div>
        </div>
    );
}

export default PoliticaPrivacidade;
